mutation TravelerApprovalCreate($input: TravelerApprovalCreateInput!) {
  travelerApprovalCreate(input: $input) {
    approvalRequestResults {
      _status
      _isSubmitted
      entityId
    }
  }
}
